// src/App.js
import React, { useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    useLocation
} from 'react-router-dom';
import HomePage from './pages/HomePage';
import LinksPage from './pages/LinksPage';
import TuftingPage from './pages/TuftingPage';
import PokemonCardsPage from './pages/PokemonCardsPage';
import FaqPage from './pages/FaqPage';
import AdminLogsPage from './pages/AdminLogsPage';
import AdminReviewsPage from './pages/AdminReviewsPage';
import AdminRealisableCardsPage from './pages/AdminRealisableCardsPage';
import AdminProductsPage from './pages/AdminProductsPage';
import AdminLoginPage from './pages/AdminLoginPage';
import ReviewFormPage from './pages/ReviewFormPage';
import ScrollToTop from './components/ScrollToTop';
import './styles/App.css';
import { startClickTracking, trackPageView } from './utils/analytics';

function App() {
    return (
        <Router>
            <ScrollToTop />
            <AppRoutes />
        </Router>
    );
}

function AppRoutes() {
    const location = useLocation();
    const pathRef = useRef(location.pathname);

    useEffect(() => {
        pathRef.current = location.pathname;
        trackPageView(location.pathname);
    }, [location.pathname]);

    useEffect(() => startClickTracking(() => pathRef.current), []);

    return (
        <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/tufting' element={<TuftingPage />} />
            <Route
                path='/cartes-pokemon-3d'
                element={<PokemonCardsPage />}
            />
            <Route path='/faq' element={<FaqPage />} />
            <Route path='/links' element={<LinksPage />} />
            <Route path='/contact' element={<LinksPage />} />
            <Route path='/admin' element={<AdminLoginPage />} />
            <Route path='/admin-analytics' element={<AdminLogsPage />} />
            <Route path='/admin-reviews' element={<AdminReviewsPage />} />
            <Route path='/admin-products' element={<AdminProductsPage />} />
            <Route path='/review/:token' element={<ReviewFormPage />} />
            <Route
                path='/admin-realisables'
                element={<AdminRealisableCardsPage />}
            />
        </Routes>
    );
}

export default App;
